export default __webpack_public_path__ + "static/media/Awake2.e2fd3694.svg";